import { _ } from "libs";
import React from "react";
import cx from "classnames";
import Avatar from "../../avatar";

const PlayerItemSmallColumn = ({
	index,
	name,
	photoUrl = "",
	dimension = "thumb3",
	owner = false,
	guest = false,
	showRemoveIcon = false,
	onRemoveClick,
	className,
}: {
	index?: number | string;
	name: string,
	photoUrl: string,
	dimension?: string;
	owner?: boolean;
	guest?: boolean;
	className?: string;
	showRemoveIcon?: boolean;
	onRemoveClick?: (index: number | string) => void;
}) => (
	<div className={cx("item", "player", "small", "column", className)}>
		<div className="itemImage">
			{showRemoveIcon ? <div className="remove" onClick={() => onRemoveClick(index)} /> : ""}
			{owner ? <div className="owner badge">{_("player.owner")}</div> : ""}
			{guest ? <div className="guest badge">{_("player.guest")}</div> : ""}
			<Avatar photoUrl={photoUrl} size={dimension} />
		</div>
		<div className="itemBody">
			<div className="title" title={name}>{name}</div>
		</div>
	</div>
);

export default PlayerItemSmallColumn;
